import "./TestCptCodesViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import TestCptCodesViewComponent from "./test-cpt-codes-view/TestCptCodesViewComponent";
import TestCptCodesEditComponent from "./test-cpt-codes-edit/TestCptCodesEditComponent";

interface TestCptCodesViewEditComponentProps {
    testDetails: any
    onUpdateInformation: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const TestCptCodesViewEditComponent = (props: TestCptCodesViewEditComponentProps) => {
    const {testDetails, onUpdateInformation, onModeChange, canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [testBasicInformation, setTestBasicInformation] = useState<any>(undefined);

    const handleTestInformationUpdate = useCallback((updatedTestInformation: any, redirectTabId?: "basic_details" | "attachments" | "configuration" | "assigned_labs" | "report_type") => {
        onUpdateInformation(updatedTestInformation, redirectTabId);
        setMode("view");
    }, [onUpdateInformation]);

    const handlePanelInformationEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (testDetails) {
            setTestBasicInformation(testDetails);
        }
    }, [testDetails]);

    useEffect(() => {
        onModeChange(mode)
    }, [mode, onModeChange])

    return (
        <div className={'test-cpt-codes-view-edit-component  details-tab-data-wrapper'}>
            {
                mode === "view" && <TestCptCodesViewComponent testDetails={testBasicInformation} canEdit={canEdit}
                                                              onEditModeOpen={() => {
                                                                  setMode("edit")
                                                              }}
                />
            }
            {
                mode === "edit" && <TestCptCodesEditComponent
                    testDetails={testBasicInformation}
                    onUpdateComplete={handleTestInformationUpdate}
                    onEditCancel={handlePanelInformationEditCancel}
                />
            }
        </div>
    );
};

export default TestCptCodesViewEditComponent;
